import React from 'react'
import config from '../config'
  
export const ConfigContext = React.createContext({
    config,
    setConfig: (config) => {}
})